const scrollAnimationObserve = new IntersectionObserver(
    (entries,scrollAnimationObserve) =>{
        entries.forEach((entry) =>{
            if(entry.isIntersecting){
                entry.target.classList.add('enter');
                scrollAnimationObserve.unobserve(entry.target);
                // console.log(entry.target)
            }
        });
    }
);

export default {
    bind(el){
        el.classList.add('before-enter');
        scrollAnimationObserve.observe(el);
    }
}


// WEBPACK FOOTER //
// ./src/directives/scrollAnimation.js